import { PatientWithAccessRightDTO } from '@peartherapeutics/weaver-api-client';
import moment, { Moment } from 'moment-timezone';
import { DATE_FORMATS } from './dateTime';

export interface IInvalidType {
  type: string;
  message: string;
}

export const invalidEmail: IInvalidType = {
  type: 'email',
  message: 'Email is invalid',
};

export const MINIMUM_PASSWORD_LENGTH = 8;
const EMAIL_REGEX = /.*@.*/;
const POSTALCODE_REGEX = /(^\d{5}-\d{4}$|^\d{5}$)/;

const parseDate = (value: string): Moment =>
  moment(value, DATE_FORMATS.M_D_YYYY_V2, true);

export const validateDate = (date: string | null | undefined): boolean => {
  return (
    date !== null &&
    date !== undefined &&
    date !== '' &&
    parseDate(date).isValid()
  );
};

export const validateEmail = (email: string): boolean => {
  return EMAIL_REGEX.test(email);
};

export const validatePassword = (password: string): boolean => {
  return password != null && password.length >= MINIMUM_PASSWORD_LENGTH;
};

export const validateName = (name: Nullable<string>): boolean => {
  return name !== null && name.trim() !== '';
};

export const validatePatient = (
  patient: PatientWithAccessRightDTO,
): {
  birthDate: boolean;
  firstName: boolean;
  lastName: boolean;
  email: boolean;
} => {
  return {
    firstName: validateName(patient.firstName),
    lastName: validateName(patient.lastName),
    email: validateEmail(patient.email),
    birthDate: validateDate(patient.birthDate),
  };
};

export const isValidPostalCode = (postalCode: string) => {
  return POSTALCODE_REGEX.test(postalCode);
};
